import React from "react";
import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";

interface SSHViewPageProps extends NSARouterMakerResult, CredentialProps { }

class SSHViewPage extends React.Component<SSHViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of an SSH credential, including its name and the private key it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
                }}
                pages={{
                    entity: CredentialEntities.ssh(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default SSHViewPage;